import { IconButton, InputAdornment, TextField, styled } from "@mui/material"
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Search } from "@mui/icons-material";

type Props = {
  value: string;
  onChange: (value: string) => void;
  customStyles?: any;
}

const SmallTextField = styled(TextField)({
  '& label': {
    fontSize: "14px",
    lineHeight: "10px"

  },
  '& input': {
    padding: "4px 8px",
    fontSize: "14px"
  },
});

export function CardSearch({ value, onChange, customStyles }: Props) {
  return <SmallTextField
    label="Search"
    value={value}
    sx={customStyles || styles.searchField}
    onChange={e => onChange(e.target.value)}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          {value ? <IconButton onClick={() => onChange('')} edge="end" size="small">
            <CloseOutlinedIcon sx={styles.fontXs} />
          </IconButton> : <Search sx={styles.fontXs} />}
        </InputAdornment>
      ),
    }}
    size="small"
  />
}

const styles = {
  searchField: {
    mt: 1,
    mr: 1,
    width: "250px"
  },
  fontXs: {
    fontSize: "14px"
  }
}